/**
 * Accès indexé sûr.
 *
 * `noUncheckedIndexedAccess` est activé : `items[i]` a le type `T | undefined`,
 * même quand l'indice est manifestement dans les bornes. L'échappatoire
 * habituelle est `items[i]!`, mais elle supprime la vérification sans rien
 * garantir : le jour où l'indice sort des bornes, on obtient `undefined` déguisé
 * en `T`, et l'erreur se manifeste très loin de sa cause.
 *
 * `at()` conserve la garantie de type ET échoue à l'endroit exact du problème.
 */
export function at(items, index) {
    const value = items[index];
    if (value === undefined) {
        throw new RangeError(`Indice ${String(index)} hors bornes (longueur ${String(items.length)}).`);
    }
    return value;
}
//# sourceMappingURL=at.js.map